import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { styled } from "@mui/material";
import Home from "../pages/home/home";
import Nav from "../components/nav/nav";
import AboutUSDesktop from "../pages/about/AboutDesktop";
import AboutUSMobile from "../pages/about/AboutUSMobile";
import PlantsCategoriesDesktop from "../pages/home/Categories/plants-categories/plantsCategoriesDesktop";
import ShapesDesktop from "../pages/home/Categories/plants-categories/Shapes/Shapes";
import FicusCategorieDesktop from "../pages/home/Categories/plants-categories/Ficus/FicusDesktop";
import CedrusFamiliesDesktop from "../pages/home/Categories/plants-categories/Cedrus/CedrusDesktop";
import PalmsCategorieDesktop from "../pages/home/Categories/plants-categories/Palms/PalmsDesktop";
import FruitsCategoriesDesktop from "../pages/home/Categories/plants-categories/Fruits/FruitsDesktop";
import AcerCategorieDesktop from "../pages/home/Categories/plants-categories/Acer/AcerDesktop";
import FlowersCategorieDesktop from "../pages/home/Categories/plants-categories/flowers/flowersDesktop";
import ClimbersCategorieDesktop from "../pages/home/Categories/plants-categories/Climbers/climbersDesktop";
import BlossomCategorieDesktop from "../pages/home/Categories/plants-categories/Blossom/BlossomDesktop";
import IndoorsDesktop from "../pages/home/Categories/plants-categories/Indoors/indoorsDesktop";
import PlantsCategoriesMobile from "../pages/home/Categories/plants-categories/plantsCategoriesMobile";
import AcerCategorieMobile from "../pages/home/Categories/plants-categories/Acer/AcerMobile";
import ShapesMobile from "../pages/home/Categories/plants-categories/Shapes/shapesMobile";
import FicusCategorieMobile from "../pages/home/Categories/plants-categories/Ficus/FicusMobile";
import CedrusFamiliesMobile from "../pages/home/Categories/plants-categories/Cedrus/CedrusMobile";
import PalmsCategorieMobile from "../pages/home/Categories/plants-categories/Palms/palmsMobile";
import FruitsCategoriesMobile from "../pages/home/Categories/plants-categories/Fruits/FruitsMobile";
import FlowersCategorieMobile from "../pages/home/Categories/plants-categories/flowers/flowersMobile";
import ClimbersCategorieMobile from "../pages/home/Categories/plants-categories/Climbers/climbersMobile";
import BlossomCategorieMobile from "../pages/home/Categories/plants-categories/Blossom/BlossomMobile";
import IndoorsMobile from "../pages/home/Categories/plants-categories/Indoors/indoorsMobile";
import AboutUSDetailsDesktop from "../pages/about/aboutDetailsDesktop";
import FlowerDetail from "../pages/home/Categories/plants-categories/flowers/flowerDetailsDesktop";
import FlowerDetailMobile from "../pages/home/Categories/plants-categories/flowers/flowerDetailsMobile";
import FlowerDetailDesktop from "../pages/home/Categories/plants-categories/flowers/flowerDetailsDesktop";
import AcerDetailsPage from "../pages/home/Categories/plants-categories/Acer/acerDetails.Desktop";
import IndoorDetails from "../pages/home/Categories/plants-categories/Indoors/indoor-details";
import FlowersDetails from "../pages/home/Categories/plants-categories/flowers/flower-details";
import ScrollToTop from "../components/scrollToTop";
import FicusDetails from "../pages/home/Categories/plants-categories/Ficus/ficus-details";
import OlivesDesktop from "../pages/home/Categories/plants-categories/Olives/olivesDesktop";
import OlivesDetails from "../pages/home/Categories/plants-categories/Olives/olives-details";
import OlivesMobile from "../pages/home/Categories/plants-categories/Olives/olivesMobile";
import QuercusDesktop from "../pages/home/Categories/plants-categories/Quercus/quercusDesktop";
import QuercusDetails from "../pages/home/Categories/plants-categories/Quercus/quercus-details";
import QuercusMobile from "../pages/home/Categories/plants-categories/Quercus/quercusMobile";


interface LayoutProps {
  children: React.ReactNode;
}

interface MainProps {
  open: boolean;
  children: React.ReactNode;
  ismobile: boolean;
}

const Layout = styled("div")<LayoutProps>(({ theme }) => ({
  backgroundColor: "#EDEADE",
  // backgroundColor: "#c9cec0",
  display: "flex",
  height: "100%",
  overflow: "hidden",
  width: "100%",
}));

const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "ismobile",
})<MainProps>(({ theme, open, ismobile }) => ({
  flexGrow: 1,
  marginTop: "65px",
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflow: "auto",

  WebkitOverflowScrolling: "touch",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: Boolean(ismobile) ? 0 : "220px",
    // backgroundColor: "#EDEADE",
  }),
}));

export function SpecialLayout() {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isTablet, setIsTablet] = useState<boolean>(false);
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 888);
      setIsTablet(window.innerWidth <= 1200);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  return (
    <>
      <Layout>
        <Nav />
        <Main open={false} ismobile={isMobile}>
          <ScrollToTop />
          <Routes>
            {isMobile ? (
              <>
                <Route path="/" element={<Home isMobile={isMobile} />} />
                <Route path="/details" element={<AboutUSDetailsDesktop />} />
                <Route path="/plants-Categorie" element={<PlantsCategoriesMobile />} />
                <Route path="/shapes" element={<ShapesMobile />} />
                <Route path="/ficus" element={<FicusCategorieMobile />} />
                <Route path="/cedrus" element={<CedrusFamiliesMobile />} />
                <Route path="/palms" element={<PalmsCategorieMobile />} />
                <Route path="/fruits" element={<FruitsCategoriesMobile />} />
                <Route path="/acer" element={<AcerCategorieMobile />} />
                <Route path="/flowers" element={<FlowersCategorieMobile />} />
                <Route path="/flowers/:name" element={<FlowersDetails />} />
                <Route path="/climbers" element={<ClimbersCategorieMobile />} />
                <Route path="/blossom" element={<BlossomCategorieMobile />} />
                <Route path="/indoors" element={<IndoorsMobile />} />
                <Route path="/acer/:name" element={<AcerDetailsPage />} />
                <Route path="/indoors/:name" element={<IndoorDetails />} />
                <Route path="/ficus/:name" element={<FicusDetails />} />
                <Route path="/olives" element={<OlivesMobile />} />
                <Route path="/olives/:name" element={<OlivesDetails />} />
                <Route path="/quercus" element={<QuercusMobile />} />
                <Route path="/quercus/:name" element={<QuercusDetails />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Home isMobile={isMobile} />} />
                <Route path="/details" element={<AboutUSDetailsDesktop />} />
                <Route path="/plants-Categorie" element={<PlantsCategoriesDesktop />} />
                <Route path="/shapes" element={<ShapesDesktop />} />
                <Route path="/ficus" element={<FicusCategorieDesktop />} />
                <Route path="/cedrus" element={<CedrusFamiliesDesktop />} />
                <Route path="/palms" element={<PalmsCategorieDesktop />} />
                <Route path="/fruits" element={<FruitsCategoriesDesktop />} />
                <Route path="/acer" element={<AcerCategorieDesktop />} />
                <Route path="/flowers" element={<FlowersCategorieDesktop />} />
                <Route path="/flowers/:name" element={<FlowersDetails />} />
                <Route path="/climbers" element={<ClimbersCategorieDesktop />} />
                <Route path="/blossom" element={<BlossomCategorieDesktop />} />
                <Route path="/indoors" element={<IndoorsDesktop />} />
                <Route path="/acer/:name" element={<AcerDetailsPage />} />
                <Route path="/indoors/:name" element={<IndoorDetails />} />
                <Route path="/ficus/:name" element={<FicusDetails />} />
                <Route path="/olives" element={<OlivesDesktop />} />
                <Route path="/olives/:name" element={<OlivesDetails />} />
                <Route path="/quercus" element={<QuercusDesktop />} />
                <Route path="/quercus/:name" element={<QuercusDetails />} />

              </>
            )}


          </Routes>
        </Main>
      </Layout>
    </>
  );
}
